import React from 'react';
import { Box, Card, CardActionArea, CardContent, Container, Stack, Typography } from '@mui/material';
import {
  History as HistoryIcon,
  MailOutline as MailOutlineIcon,
  Description as DescriptionIcon,
  AutoMode as AutoModeIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const cards = [
  {
    title: 'Nouveau message',
    description: 'Composer et envoyer un message aux apprenants d’une formation.',
    path: '/student-messages/compose',
    icon: <MailOutlineIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
  },
  {
    title: 'Templates messages',
    description: 'Créer et modifier les modèles d’emails réutilisables.',
    path: '/student-messages/templates',
    icon: <DescriptionIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
  },
  {
    title: 'Relances automatiques',
    description: 'Templates par défaut pour chaque trigger de relance (première activation formation).',
    path: '/student-messages/reminder-defaults',
    icon: <AutoModeIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
  },
  {
    title: 'Envois planifiés et historique',
    description: 'Consulter, modifier ou annuler les envois programmés et voir les rapports.',
    path: '/student-messages/batches',
    icon: <HistoryIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
  },
];

const StudentMessagesHub: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box mb={4}>
        <Typography variant="h4" gutterBottom>
          Message apprenant
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Envoyez des emails personnalisés, gérez vos templates et suivez vos campagnes.
        </Typography>
      </Box>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
        {cards.map((card) => (
          <Card key={card.path} sx={{ flex: 1 }}>
            <CardActionArea onClick={() => navigate(card.path)} sx={{ height: '100%' }}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>{card.icon}</Box>
                <Typography variant="h6" gutterBottom fontWeight={700}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Container>
  );
};

export default StudentMessagesHub;
